import router from '@/router';
import LinkedOrder from '@/routers/LinkedOrder';

export default {
    state:
    {
        userMsg: {},
    },
    getters: {},
    mutations:
    {
        setUserMsg(state: any, list: Object) {
            state.userMsg = list;
        },
    },
    actions:
    {
        async getUserMsg({ commit }: any, params: Array<any>) {
            const { error, success }: any = await router.app.$request('USER_MSG', params);
            success && commit('setUserMsg', success.data);
            return { error, success };
        },
        async getCouponList({ commit }: any, params: any) {
            const { error, success }: any = await router.app.$request('LINKORDER_LIST', params);
            return { error, success };
        },
        async LinkedOrder({ commit }: any, params: any) {
            const { error, success }: any = await router.app.$request('LINKORDER_LINK', params);
            return { error, success };
        },
    },

};